import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const initialTime = 22 * 3600 + 47 * 60 + 22;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="flex flex-col items-center space-y-2 sm:space-y-4 w-full max-w-md mx-auto my-4 sm:my-8" data-id="element-63">
      <div className="w-full bg-navy-800 rounded-full h-3 sm:h-4 overflow-hidden border border-navy-700" data-id="element-64">
        <div className="bg-magenta-500 h-full rounded-full transition-all duration-1000 relative overflow-hidden" style={{
        width: '68%'
      }} data-id="element-65">
          <div className="absolute inset-0 bg-white/20 w-full animate-[shimmer_2s_infinite] -translate-x-full" style={{
          backgroundImage: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)'
        }} data-id="element-66" />
        </div>
      </div>
      <div className="flex justify-between w-full text-xs sm:text-sm text-gray-400 font-medium" data-id="element-67">
        <span data-id="element-68">Cupos al precio de lanzamiento</span>
        <span className="text-magenta-500 font-bold" data-id="element-69">68% tomados</span>
      </div>

      <div className="text-center mt-2 sm:mt-4" data-id="element-70">
        <p className="text-gold-400 font-bold uppercase tracking-wider text-xs sm:text-sm mb-1 sm:mb-2" data-id="element-71">
          EL PRECIO DE LANZAMIENTO TERMINA EN:
        </p>
        <div className="flex items-center justify-center space-x-1.5 sm:space-x-2 text-2xl sm:text-3xl md:text-4xl font-black tabular-nums" data-id="element-72">
          <div className="bg-navy-800 border border-navy-700 text-white px-2 py-1.5 sm:px-3 sm:py-2 rounded-lg min-w-[2.5ch] sm:min-w-[3ch] text-center" data-id="element-73">
            {formatTime(hours)}
          </div>
          <span className="text-gold-500" data-id="element-74">:</span>
          <div className="bg-navy-800 border border-navy-700 text-white px-2 py-1.5 sm:px-3 sm:py-2 rounded-lg min-w-[2.5ch] sm:min-w-[3ch] text-center" data-id="element-75">
            {formatTime(minutes)}
          </div>
          <span className="text-gold-500" data-id="element-76">:</span>
          <div className="bg-navy-800 border border-navy-700 text-white px-2 py-1.5 sm:px-3 sm:py-2 rounded-lg min-w-[2.5ch] sm:min-w-[3ch] text-center text-magenta-500" data-id="element-77">
            {formatTime(seconds)}
          </div>
        </div>
        <p className="text-gray-400 text-xs sm:text-sm mt-2 sm:mt-3" data-id="element-78">
          Después sube{' '}
          <span className="text-white font-semibold" data-id="element-79">$8.000 ARS</span> y no
          vuelve a bajar.
        </p>
      </div>
    </div>;
}